import { render } from "./FacetFilter.vue?vue&type=template&id=31dbe838&scoped=true"
import script from "./FacetFilter.vue?vue&type=script&lang=js"
export * from "./FacetFilter.vue?vue&type=script&lang=js"

import "./FacetFilter.vue?vue&type=style&index=0&id=31dbe838&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31dbe838"]])

export default __exports__